






















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import ShippingAreaDisplay from '@ui/ShippingArea/ShippingAreaDisplay'

settings =
  name: 'ShippingAreaShow'

  resources:
    shipping_area:
      resourceName: 'shipping_area'
      slug: 'suppliers/:supplierId/shipping_areas/:shippingAreaId'

  components: {
    LoadingIndicator,
    ShippingAreaDisplay,
  }

  vue:
    data: ->
      modal:
        show: true

    computed:
      member: -> @$store.member
      supplierId: -> @member.supplier.id

    methods:
      hiClose: -> @$router.back()

      hiNavToEditStep: (step) ->
        params = { shippingAreaId: @shipping_area.id }
        query = { step }
        @$router.push { name: 'ShippingAreaEditPage', params, query }

export default VueOptions.vue settings
